import i18n from './i18n'
export const setTitleMixIn = {
  created(): void {
    // FIXME: うまい解決方法が思いつかない…。
    // @ts-ignore: No type definition for $options
    if (this!.$options.title) {
      const siteName = 'ABEJA Agently'
      // @ts-ignore: No type definition for $options
      const title = `Menu.${this.$options.title}`
      document.title = `${i18n.t(title)} | ${siteName}`
    }
  }
}
export default setTitleMixIn
